function serialize(element, children, attributes) {
  const serializedAttributes = serializeAttributes(attributes);
  return `<${element}${serializedAttributes}>${children}</${element}>`;
}
function serializeAttributes(attributes) {
  if (attributes) {
    const attributesWithSerializedStyle = {
      ...attributes,
      style: attributes.style ? serializeStyle(attributes.style) : ''
    };
    return Object.keys(attributesWithSerializedStyle).sort().reduce((acc, key) => {
      const value = attributesWithSerializedStyle[key];
      if (!value || typeof value !== typeof 'string') {
        return acc;
      }
      return `${acc} ${key}="${escapeAttribute(value)}"`;
    }, '');
  }
  return '';
}
function serializeStyle(style) {
  return Object.keys(style).reduce((acc, key) => `${acc + key.split(/(?=[A-Z])/).join('-').toLowerCase()}:${escapeSerializedStyle(style[key])};`, '');
}
function escapeAttribute(value) {
  return value.replace(/"/g, '&quot;');
}
function escapeSerializedStyle(value) {
  return value.replace(/"/g, "'");
}

export { serialize, serializeAttributes, serializeStyle };
